import { render } from "./ArchiveConfirmModal.vue?vue&type=template&id=cf1f2ad4"
import script from "./ArchiveConfirmModal.vue?vue&type=script&lang=js"
export * from "./ArchiveConfirmModal.vue?vue&type=script&lang=js"

import "./ArchiveConfirmModal.vue?vue&type=style&index=0&id=cf1f2ad4&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__